/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each metric is one axis; each item is one polygon.`)
};

const es_radar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada métrica es un eje; cada elemento es un polígono.`)
};

const de_radar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Kennzahl ist eine Achse; jedes Element ist ein Polygon.`)
};

const nl_radar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke metric is één as; elk item is één veelhoek.`)
};

const fr_radar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque métrique est un axe ; chaque élément est un polygone.`)
};

const it_radar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni metrica è un asse; ogni elemento è un poligono.`)
};

const pt_br2_radar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada métrica é um eixo; cada item é um polígono.`)
};

const pt_radar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada métrica é um eixo; cada item é um polígono.`)
};

const ja_radar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各指標が1つの軸に、各項目が1つの多角形になります。`)
};

const zh_radar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个指标是一条轴；每个项目是一个多边形。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_ex2", locale)
	if (locale === "en") return en_radar_ex2(inputs)
	if (locale === "es") return es_radar_ex2(inputs)
	if (locale === "de") return de_radar_ex2(inputs)
	if (locale === "nl") return nl_radar_ex2(inputs)
	if (locale === "fr") return fr_radar_ex2(inputs)
	if (locale === "it") return it_radar_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_radar_ex2(inputs)
	if (locale === "pt") return pt_radar_ex2(inputs)
	if (locale === "ja") return ja_radar_ex2(inputs)
	return zh_radar_ex2(inputs)
};